import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import { ActivationTypes } from '../actions/ActivationActions';

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
  error: '',
  activated: false,
  fetching: false,
});

/* ------------- Reducers ------------- */
export const onRequest = (state) => state.merge({ fetching: true });
export const onFailure = (state, { error }) =>
  state.merge({ fetching: false, error });
export const onSaveSuccess = (state) =>
  state.merge({ fetching: false, activated: true });

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [ActivationTypes.ACTIVATION_REQUEST]: onRequest,
  [ActivationTypes.ACTIVATION_SUCCESS]: onSaveSuccess,
  [ActivationTypes.ACTIVATION_FAILURE]: onFailure,
});

/* ------------- Selectors ------------- */
export const isActivated = (state) => state.activation.activated;
export const getError = (state) => state.activation.error;
export const isFetching = (state) => state.activation.fetching;



// WEBPACK FOOTER //
// ./src/state/reducers/ActivationReducer.js